import { hideModal } from "global/context/action/modal/modal";
import { GlobalContext } from "global/context/Provider";
import { useContext } from "react";
import { ContainerModalCentro, InfoCentroBox } from "./localStyle";

const AdvertenciaCentro = ({ tomarTurno, infoTurno }) => {
  const { modalDispatch } = useContext(GlobalContext);

  const onClickTurno = () => {
    hideModal()(modalDispatch);
    tomarTurno();
  };

  return (
    <ContainerModalCentro>
      <p>
        El turno que seleccionaste no se encuentra cerca de tu ubicación, deberás
        dirigirte al centro que corresponde para poder tomar el turno.
      </p>
      <InfoCentroBox>
        <p className="rb16m">{infoTurno?.centro}</p>
        <p className="rb16m">{infoTurno?.direccion}</p>
      </InfoCentroBox>
      {/* <p>¿Deseas tomar el turno de todas formas?</p> */}

      <div className="container-btn">
        <button
          className="bgc-latex30 cancelar"
          onClick={() => hideModal()(modalDispatch)}
        >
          Cerrar
        </button>
        {/* <button className="bgc-primary cancelar" onClick={() => onClickTurno()}>
          Tomar Turno
        </button> */}
      </div>
    </ContainerModalCentro>
  );
};
export default AdvertenciaCentro;
